import classNames from 'classnames';
import React from 'react';

import {AvatarSize, AvatarShape} from './AvatarConstants';

const DEFAULT_AVATAR_SHAPE = AvatarShape.CIRCLE;

interface AvatarTextProps {
  text: string;
  backgroundColor: string;
  className?: string;
  size: AvatarSize;
  shape: AvatarShape;
}

/**
 * A text-only avatar with text over a circle with a background color.
 */
const AvatarText = ({
  text,
  backgroundColor,
  className,
  size,
  shape = DEFAULT_AVATAR_SHAPE,
}: AvatarTextProps): JSX.Element => (
  <span
    translate="no"
    className={classNames(`avatar avatar--text avatar--${size} avatar--${shape}`, className)}
    style={{backgroundColor}}
  >
    {text}
  </span>
);

AvatarText.defaultProps = {shape: DEFAULT_AVATAR_SHAPE};

export default AvatarText;
